const ServiceIssuesReportFrequency = {
    NEVER: 'never',
    DAILY: 'daily',
    WEEKLY: 'weekly',
    BI_WEEKLY: 'bi-weekly',
    MONTHLY: 'monthly',
};

export default ServiceIssuesReportFrequency;
